export default "__VITE_ASSET__BB8cK1iN__"